/* eslint-disable react/no-unknown-property */
import React from 'react';
import cn from 'classnames';

import { mq } from 'react-scale/components/website/big/Themes';

const Tooltip = ({ showTooltip, type, content, text }) => (
  <div className={cn(showTooltip === type ? 'show' : '')}>
    {content && (
      <ul>
        {content.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )}
    {text && <p>{text}</p>}
    <style jsx>{`
      div {
        background: white;
        width: 280px;
        box-shadow: var(--box-shadow);
        border-radius: var(--border-radius);
        padding: calc(2rem / 2);
        position: absolute;
        left: 0;
        bottom: 50px;
        opacity: 0;
        transform: scale(0) translateZ(0);
        transition: all 250ms ease-out 250ms;
        transform-origin: left bottom;
        box-sizing: border-box;
      }
      @media (min-width: ${mq.md}) {
        div {
          width: 365px;
        }
      }
      @media (min-width: ${mq.lg}) {
        div {
          width: 465px;
        }
      }
      div.show {
        opacity: 1;
        transform: scale(1) translateZ(0);
        transition: all 250ms ease-out;
      }
      div.show ul {
        opacity: 1;
        transition: all 250ms ease-out 250ms;
      }
      div:before {
        content: '';
        position: absolute;
        bottom: -12px;
        left: calc(2rem * 2);
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid white;
        transform: translate3d(-50%, 0, 0);
      }
      @media (min-width: ${mq.lg}) {
        div:before {
          left: 50px;
          transform: translate3d(0, 0, 0);
        }
      }

      ul {
        margin: 0;
        padding: 0 0 0 calc(2rem / 2);
        opacity: 0;
        transition: all 250ms ease-out;
        list-style-type: disc;
      }
    `}</style>
  </div>
);

export default Tooltip;
